import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { RouterModule } from '@angular/router';

import { EnvServiceProvider } from './custom-material/Services/env.service.provider';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
registerLocaleData(localeFr, 'fr-FR', localeFrExtra);
import localeEn from '@angular/common/locales/en';
import localeEnExtra from '@angular/common/locales/extra/en';
registerLocaleData(localeEn, 'en-GB', localeEnExtra);
import { TranslocoRootModule } from './transloco/transloco-root.module';


import { MainModule } from './main/main.module';
import { BuildingsModule } from './buildings/buildings.module';
import { AuditModule } from './audit/audit.module';
import { SynthesisModule } from './synthesis/synthesis.module';
import { IncidentsModule } from './incidents/incidents.module';
import { StatisticsModule } from './statistics/statistics.module';
import { RiskManagementModule } from './risk-management/risk-management.module';

import { CustomMaterialModule } from './custom-material/custom-material.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './appcomponents/login/login.component';
import { IntroComponent } from './appcomponents/intro/intro.component';
import { GlobalDataProvider } from './main/Models/global.model.provider';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [
    AppComponent,
    IntroComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ChartsModule,
    RouterModule,
    MainModule,
    BuildingsModule,
    AuditModule,
    SynthesisModule,
    IncidentsModule,
    StatisticsModule,
    RiskManagementModule,
    CustomMaterialModule,
    HttpClientModule,
    TranslocoRootModule
  ],
  providers: [EnvServiceProvider, GlobalDataProvider],
  bootstrap: [AppComponent]
})
export class AppModule { }
